'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchQueryParser = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _google = require('./google');

var _listingMapping = require('./listing-mapping');

var _specialtyMapping = require('./specialty-mapping');

var moment = require('moment');

var transformSeletedLocation = function transformSeletedLocation(location) {
  return location ? {
    name: location.formatted_address,
    locationFilterClass: (0, _google.getFilterClass)(location.types),
    value: {
      lng: location.geometry.location.lng(),
      lat: location.geometry.location.lat()
    }
  } : null;
};

var searchQueryParser = exports.searchQueryParser = function searchQueryParser(parsedQueryArg, listings) {
  return new Promise(function (resolve, reject) {
    try {
      var parsedQuery = parsedQueryArg || {};
      /**
      A little bit of explaination is necessary here:
      There was a bit of black magic in the previous Angular website.
      in order to be backward compatible wtih previous urls, we need to check
      the query parameters to get the needed information for the search endpoint.
      **/
      if (parsedQuery && (typeof parsedQuery === 'undefined' ? 'undefined' : _typeof(parsedQuery)) === 'object') {
        Object.keys(parsedQuery).map(function (key) {
          if (typeof parsedQuery[key] === 'string') {
            parsedQuery[key] = decodeURIComponent(parsedQuery[key]);
          }
        });
      }
      var operation = void 0;
      if (parsedQuery.location) {
        operation = (0, _google.placesAutocomplete)(parsedQuery.location).then(function (locations) {
          return locations && locations.length ? (0, _google.geocodeByPlaceId)(locations[0].place_id) : Promise.resolve();
        }).then(function (results) {
          return results && results.length ? Promise.resolve(transformSeletedLocation(results[0])) : Promise.resolve();
        });
      } else if (parsedQuery.search_center) {
        operation = Promise.resolve({
          name: parsedQuery.location,
          value: {
            lat: parsedQuery.search_center.split(',')[0],
            lng: parsedQuery.search_center.split(',')[1]
          }
        });
      } else if (parsedQuery.placeId) {
        operation = (0, _google.geocodeByPlaceId)(parsedQuery.placeId).then(function (results) {
          return results && results.length ? Promise.resolve(transformSeletedLocation(results[0])) : Promise.resolve();
        });
      } else {
        /*Found no location information, set it up to  null*/
        operation = Promise.resolve();
      }

      operation.then(function (location) {
        var query = {
          selectedLocation: location || undefined,
          text: parsedQuery.text || undefined,
          selectedGender: parsedQuery.gender ? parsedQuery.gender.toLowerCase() : undefined,
          selectedKeyword: (0, _listingMapping.getTreatmentGroupByName)(listings.healthChecksTreatmentGroups, parsedQuery.healthCheck) || (0, _listingMapping.getTreatmentGroupByName)(listings.scansTreatmentGroups, parsedQuery.scan) || (0, _specialtyMapping.getSpecialtyByNameOrPractitioner)(listings.specialties, parsedQuery.specialty) || (0, _listingMapping.getConditionByName)(listings.conditions, parsedQuery.condition) || (0, _listingMapping.getProcedureByName)(listings.procedures, parsedQuery.procedure) || undefined,
          selectedLanguage: (0, _listingMapping.getLanguageByName)(listings.languages, parsedQuery.language) || undefined,
          selectedInsurer: (0, _listingMapping.getInsurerByName)(listings.insurers, parsedQuery.insurer) || undefined,
          selectedDates: parsedQuery.startdate && parsedQuery.enddate ? [moment.utc(parsedQuery.startdate), moment.utc(parsedQuery.enddate)] : undefined,
          selectedPage: parsedQuery.page || undefined,
          selectedWithin: parsedQuery.search_radius ? { name: 'within ' + parsedQuery.search_radius + ' miles', value: parsedQuery.search_radius } : undefined,
          selectedTypesFilter: parsedQuery.types_filter ? { name: parsedQuery.types_filter, value: parsedQuery.types_filter } : undefined,
          selectedSortType: parsedQuery.sort ? { name: parsedQuery.sort, value: parsedQuery.sort } : { name: 'relevance', value: 'relevance' },
          searchType: parsedQuery.search_type || 'appointments',
          selectedHealthCheck: (0, _listingMapping.getHealthCheckByName)(listings.healthChecks, parsedQuery.healthCheck) || (0, _listingMapping.getHealthCheckByName)(listings.healthChecks, parsedQuery.scan) || undefined,
          videoConsultation: parsedQuery.videoConsultation || undefined,
          network: parsedQuery.network || undefined
        };
        return resolve({ query: query });
      });
    } catch (e) {
      return reject(e);
    }
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/doctify-utils/lib/search-query-parser.js
// module id = 1528
// module chunks = 0